// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lipper-rating {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.lipper-rating__subheader {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  gap: 8px;
  width: 100%;
  padding-bottom: 8px;
  box-shadow: inset 0 -1px 0 var(--border-line);
  background-color: var(--surface-primary);
}

.lipper-rating__subheader-title {
  flex: 1 0 0;
  min-width: 0;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
}

.lipper-rating__subheader-meta {
  flex-shrink: 0;
  text-align: right;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
}

.lipper-rating__scores {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: stretch;
  gap: 24px;
  width: 100%;
  padding: 16px 0 8px 0;
}

.lipper-rating__score {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
}

.lipper-rating__score-label {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  font-weight: 400;
  font-size: 14px;
  text-align: center;

  color: var(--accent-primary);
}

.lipper-rating__score-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid var(--accent-primary);
  box-sizing: border-box;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 14px;
  line-height: 29px;
  letter-spacing: -0.4px;
  color: var(--accent-primary);
  background-color: transparent;
}

.lipper-rating__score-badge--filled {
  border-color: var(--accent-primary);
  background-color: var(--accent-primary);
  color: var(--text-invert);
}

@container (max-width: 480px) {
  .lipper-rating__scores {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
}

@container (min-width: 768px) {
  .lipper-rating__score-label {
    font-size: 16px;
  }
  .lipper-rating__scores {
    padding-top: 32px;
  }
  .lipper-rating__score-badge {
    width: 48px;
    height: 48px;
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/components/LipperRating/LipperRating.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;;EAE3B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;;EAElB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,sBAAsB;EACtB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".lipper-rating {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.lipper-rating__subheader {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  gap: 8px;\n  width: 100%;\n  padding-bottom: 8px;\n  box-shadow: inset 0 -1px 0 var(--border-line);\n  background-color: var(--surface-primary);\n}\n\n.lipper-rating__subheader-title {\n  flex: 1 0 0;\n  min-width: 0;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n}\n\n.lipper-rating__subheader-meta {\n  flex-shrink: 0;\n  text-align: right;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n}\n\n.lipper-rating__scores {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  align-items: stretch;\n  gap: 24px;\n  width: 100%;\n  padding: 16px 0 8px 0;\n}\n\n.lipper-rating__score {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n}\n\n.lipper-rating__score-label {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  font-weight: 400;\n  font-size: 14px;\n  text-align: center;\n\n  color: var(--accent-primary);\n}\n\n.lipper-rating__score-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: auto;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 3px solid var(--accent-primary);\n  box-sizing: border-box;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 29px;\n  letter-spacing: -0.4px;\n  color: var(--accent-primary);\n  background-color: transparent;\n}\n\n.lipper-rating__score-badge--filled {\n  border-color: var(--accent-primary);\n  background-color: var(--accent-primary);\n  color: var(--text-invert);\n}\n\n@container (max-width: 480px) {\n  .lipper-rating__scores {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n  }\n}\n\n@container (min-width: 768px) {\n  .lipper-rating__score-label {\n    font-size: 16px;\n  }\n  .lipper-rating__scores {\n    padding-top: 32px;\n  }\n  .lipper-rating__score-badge {\n    width: 48px;\n    height: 48px;\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
